export default class CacheWithExpiry {
  constructor(expiryTimeInMs) {
    this.cache = new Map();
    this.expiryTimeInMs = expiryTimeInMs || 900000;
  }

  set(key, data) {
    const timestamp = Date.now();
    const cacheEntry = { data, timestamp };
    this.cache.set(key, cacheEntry);
  }

  get(key) {
    const cacheEntry = this.cache.get(key);

    if (!cacheEntry) return null;

    const currentTime = Date.now();
    const isExpired = currentTime - cacheEntry.timestamp > this.expiryTimeInMs;

    if (isExpired) {
      this.cache.delete(key);
      return null;
    }

    return cacheEntry.data;
  }

  clear() {
    this.cache.clear();
  }

  has(key) {
    return this.get(key) !== null;
  }
}
